import ApiProxy from './src';

export default ApiProxy;
